import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=472e1035&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=ts&"
export * from "./Faqs.vue?vue&type=script&lang=ts&"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=472e1035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472e1035",
  null
  
)

export default component.exports